import React from 'react';
import styled from 'styled-components';
import BackArrow from '../../../../assets/images/BackArrow.svg';
import { IAboutText } from '../components/About';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000001;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  background: #fffaf7;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

const CloseButton = styled.button`
  display: flex;
  padding-top: 3rem;
  padding-left: 7.5rem;
  padding-right: 7.5rem;
  background: transparent;
  border: none;
  color: black;
  font-size: 20px;
  cursor: pointer;
  @media screen and (max-width: 900px) {
    padding-top: 3rem;
    padding-bottom: 1rem;
    padding-left: 1.5rem;
  }
`;

const ContentContainer = styled.div`
  padding: 2rem 7.5rem;
  overflow-y: scroll;
  @media screen and (max-width: 900px) {
    padding-top: 2rem;
    padding-bottom: 1rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
`;

const Title = styled.h2`
  font-size: 24px;
  padding-bottom: 1rem;
`;

const Data = styled.p`
  font-family: 'neueMontreal-Regular';
  line-height: 1.85rem;
  font-size: 1rem;
  border: 1px solid #c6ccff;
  padding: 1.5rem;
  border-radius: 10px;
`;

interface AboutStocksPageProps {
  onClose: () => void;
  aboutCompany: IAboutText;
}

export const AboutStocksPage: React.FC<AboutStocksPageProps> = ({
  onClose,
  aboutCompany,
}) => {
  return (
    <ModalOverlay>
      <ModalContent>
        <CloseButton onClick={onClose}>
          <img src={BackArrow} alt="BackArrow" width={25} height={25} />
        </CloseButton>
        <ContentContainer>
          <Title>{aboutCompany.name}</Title>
          <Data>{aboutCompany.about}</Data>
        </ContentContainer>
      </ModalContent>
    </ModalOverlay>
  );
};
